import React, { useState, useContext } from 'react';
import './MobileApplications.css';
import Footer from '../components/Footer';
import { LanguageContext } from '../translations/LanguageContext';

function MobileApplications() {
  // Use language context for translations
  const { language, translations } = useContext(LanguageContext);
  const t = translations[language].mobileApplicationsPage;
  
  // State to handle active tab
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="mobile-applications-page">
      {/* Hero Section */}
      <header className="ma-hero">
        <div className="ma-hero-content">
          <h1>{t.heroTitle}</h1>
          <h2>{t.heroSubtitle}</h2>
          <p className="ma-hero-subtitle">{t.heroTech}</p>
        </div>
        <div className="ma-hero-image">
          <img 
            src="/MobileApplications/LOKIMockup.png" 
            alt={t.heroImageAlt} 
            className="ma-hero-img"
          />
        </div>
      </header>

      {/* Tabs Navigation */}
      <nav className="ma-tabs">
        <button 
          className={activeTab === 'overview' ? 'active' : ''}
          onClick={() => setActiveTab('overview')}
        >
          {t.tabOverview}
        </button>
        <button 
          className={activeTab === 'features' ? 'active' : ''}
          onClick={() => setActiveTab('features')}
        >
          {t.tabFeatures}
        </button>
        <button 
          className={activeTab === 'development' ? 'active' : ''}
          onClick={() => setActiveTab('development')}
        >
          {t.tabDevelopment}
        </button>
        <button 
          className={activeTab === 'testing' ? 'active' : ''}
          onClick={() => setActiveTab('testing')}
        >
          {t.tabTesting}
        </button>
      </nav>

      {/* Content based on active tab */}
      <section className="ma-content-section">
        {activeTab === 'overview' && (
          <div className="ma-content-block">
            <h2>{t.overviewTitle}</h2>
            <div className="ma-summary-row">
              <div className="ma-summary-text">
                {t.overviewParagraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <div className="ma-summary-image">
                <img 
                  src="/MobileApplications/SideMenu.png" 
                  alt={t.sideMenuImageAlt}
                  className="ma-feature-img"
                />
              </div>
            </div>
            
            <div className="ma-tech-stack">
              <h3>{t.techStackTitle}</h3>
              <div className="ma-tech-grid">
                {t.techStack.map((tech, index) => (
                  <div key={index} className="ma-tech-item">{tech}</div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === 'features' && (
          <div className="ma-content-block">
            <h2>{t.featuresTitle}</h2>
            
            {t.features.map((feature, index) => (
              <div key={index} className="ma-feature-section">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                
                {feature.images && (
                  <div className={feature.images.length > 1 ? "ma-feature-images" : "ma-feature-image-full"}>
                    {feature.images.length > 1 ? 
                      feature.images.map((img, imgIndex) => (
                        <div key={imgIndex} className="ma-feature-card">
                          <img 
                            src={img.src} 
                            alt={img.alt} 
                            className="ma-feature-img"
                          />
                          <p>{img.caption}</p>
                        </div>
                      )) : 
                      feature.images.map((img, imgIndex) => (
                        <React.Fragment key={imgIndex}>
                          <img 
                            src={img.src} 
                            alt={img.alt} 
                            className="ma-feature-img-large"
                          />
                          <p>{img.caption}</p>
                        </React.Fragment>
                      ))
                    }
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {activeTab === 'development' && (
          <div className="ma-content-block">
            <h2>{t.developmentTitle}</h2>
            
            <div className="ma-development-process">
              <h3>{t.agileTitle}</h3>
              <p>{t.agileDescription}</p>
              
              <div className="ma-sprints-timeline">
                {t.sprints.map((sprint, index) => (
                  <div key={index} className="ma-sprint-card">
                    <div className="ma-sprint-header">
                      <h4>{sprint.title}</h4>
                    </div>
                    <ul>
                      {sprint.tasks.map((task, taskIndex) => (
                        <li key={taskIndex}>{task}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="ma-section">
              <h3>{t.epicsTitle}</h3>
              <p>{t.epicsDescription}</p>
              <ul className="ma-epic-list">
                {t.epics.map((epic, index) => (
                  <li key={index}>{epic}</li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'testing' && (
          <div className="ma-content-block">
            <h2>{t.testingTitle}</h2>
            
            <div className="ma-testing-method">
              <h3>{t.methodologyTitle}</h3>
              <p>{t.methodologyDescription}</p>
            </div>
            
            <div className="ma-testing-tasks">
              <h3>{t.tasksTitle}</h3>
              <ul>
                {t.tasks.map((task, index) => (
                  <li key={index}>{task}</li>
                ))}
              </ul>
            </div>
            
            <div className="ma-testing-results">
              <h3>{t.resultsTitle}</h3>
              <div className="ma-results-categories">
                {t.resultCategories.map((category, index) => (
                  <div key={index} className="ma-result-category">
                    <h4>{category.title}</h4>
                    <ul>
                      {category.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="ma-conclusion">
              <h3>{t.conclusionTitle}</h3>
              <p>{t.conclusionText}</p>
            </div>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}

export default MobileApplications;
